/** Scanbrix CRM operators (shell login + Settings display). Keep emails in sync with `functions/shellAuth.js`. */
export const CRM_OPERATORS = [
  { email: "pulkit@scanbrix.com", name: "Pulkit", uid: "crm_shell_pulkit" },
  { email: "greg@scanbrix.com", name: "Greg", uid: "crm_shell_greg" },
];

/** Custom-token users often have no `user.email`; map shell uid → operator email for UI. */
export function displayEmailForAuthUser(user) {
  if (!user) return "";
  const op = CRM_OPERATORS.find((o) => o.uid === user.uid);
  return op?.email || user.email || user.uid;
}
